<template>
	<el-table
		:data="orderedWater"
		:show-header="false"
		max-height="300px">
		<el-table-column label="Date" width="100">
			<template slot-scope="scope">
				<strong class="date">{{ formatDate(scope.row.time) }}</strong>
			</template>
		</el-table-column>

		<!-- Value -->
		<el-table-column label="Value">
			<template slot-scope="scope">
				<strong>{{ scope.row.value }}</strong> cups
			</template>
		</el-table-column>

		<!-- Details -->
		<el-table-column label="Detail">
			<template slot-scope="scope">
				&nbsp;
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import WaterAnalysis from '.'

export default {
	name: 'patient-lifestyle-card-water-table',
	extends: WaterAnalysis,

	computed: {
		orderedWater() {
			return this.water.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
